import React, { memo, useCallback } from 'react'
import { Typography } from '@mui/material'
import { ContractorPortalPartner } from 'src/interfaces/contractorPortal'
import tw from 'twin.macro'
import { ChevronRightMinor } from '@shopify/polaris-icons'
import { addS } from 'src/utils/baseUtils'

interface Props {
  partner: ContractorPortalPartner
  onClick: (partner: ContractorPortalPartner) => void
  rowDataTestId?: string
}

const ContractorPortalPartnerItemComponent = ({ partner, onClick, rowDataTestId }: Props) => {
  const handleClick = useCallback(() => {
    onClick(partner)
  }, [partner, onClick])

  return (
    <div
      css={tw`p-4 flex items-center bg-shades-0 border-0 border-t border-solid border-shades-100 justify-between hover:bg-shades-100 active:bg-shades-200 cursor-pointer`}
      onClick={handleClick}
      data-testid={rowDataTestId ?? `sign-in-select-partner-row-${partner.id}`}
    >
      <div css={tw`flex items-center`}>
        <div>
          <Typography variant="h4" css={tw`mb-0.5`}>
            {partner.displayName}
          </Typography>
          <Typography css={tw`mb-0.5 text-shades-400`}>
            {`${partner.invoicesCount} ${addS(partner.invoicesCount, 'invoice')} • ${
              partner.reportsCount
            } ${addS(partner.reportsCount, 'report')}`}
          </Typography>
        </div>
      </div>
      <ChevronRightMinor fill="black" width={20} height={20} />
    </div>
  )
}

export const ContractorPortalPartnerItem = memo(ContractorPortalPartnerItemComponent)
